export enum ButtonActionType {
  DOWNLOAD = 'download',
  USE_THIS = 'useThis',
  FILL_PROMPT = 'fill_prompt',
  UPSELL_PREMIUM = 'upsell_premium',
  UPSELL_CREDITS = 'upsell_credits',
}

export enum DownloadFileType {
  PNG = 'png',
  PDF = 'pdf',
}

export enum DownloadImageQuality {
  ORIGINAL = 'original',
  ENHANCED_4K = 'enhanced_4k',
}

export interface DownloadButtonAction {
  type: ButtonActionType.DOWNLOAD;
  chatId: string;
  hashedId: string;
  fileType: DownloadFileType;
  imageQuality: DownloadImageQuality;
}

export interface UseThisButtonAction {
  type: ButtonActionType.USE_THIS;
  chatId: string;
  hashedId: string;
}

export interface FillPromptButtonAction {
  type: ButtonActionType.FILL_PROMPT;
  chatId: string;
  text: string;
}

export interface UpsellPremiumButtonAction {
  type: ButtonActionType.UPSELL_PREMIUM;
  chatId: string;
  promoCode: string;
}

export interface UpsellCreditsButtonAction {
  type: ButtonActionType.UPSELL_CREDITS;
  chatId: string;
}

export type ButtonAction = DownloadButtonAction | UseThisButtonAction | FillPromptButtonAction | UpsellPremiumButtonAction | UpsellCreditsButtonAction;
